<div class="driver-box">
    <div class="flex-grow flexContent flexColumn spacebetween"
        [class.driver-box--cursor-pointer]="!showAdditionalDriverInfo" (click)="toggleOnShowAdditionalDriverInfo()">
        <div class="flexContent spacebetween" >
            <div>
                <div>{{ driver.model }}</div>
                <div class="driver-box--secondary-info">{{ driver.loadCapacity }}</div>
            </div>
            <div>
                <div *ngIf="driver.codeFromDescription" [matTooltip]="driver.codeFromDescription"
                    class="driver-box__code-from-description driver-box--no-break">
                    {{ driver.codeFromDescription }}
                </div>
                <!-- <div *ngIf="showCollapseButtons">
                    <button type="button" *ngIf="isRowExpanded" (click)="collapseRow.emit()">C</button>
                    <button type="button" *ngIf="!isRowExpanded" (click)="expandRow.emit()">E</button>
                </div> -->
            </div>
        </div>

        <div class="driver-box__main-info">
            <div><span *ngIf="showDebugInfo"> ({{ driver.driverId }}) </span> {{ driver.driverDisplayName }}</div>
            <div><span *ngIf="showDebugInfo"> ({{ driver.vehicleId }}) </span> {{ driver.registrationNumber }}
                <span *ngIf="driver.trailerRegistrationNumber.length > 0">
                    / <span *ngIf="showDebugInfo"> ({{ driver.trailerId }}) </span>
                    {{ driver.trailerRegistrationNumber }} </span>
            </div>
        </div>

        <div class="driver-box--secondary-info">{{ driver.region }}</div>
        <ng-content *ngIf="showAdditionalDriverInfo">
            <div class="driver-box--break-word driver-box--secondary-info"> {{ driver.driver.PhoneNumber}} </div>
            <div class="driver-box--break-word driver-box--secondary-info"> {{ driver.driver.Email}} </div>
        </ng-content>
    </div>

    <div class="driver-box__box-fotter">
        <button type="button" class="driver-box--secondary-info" matTooltip="Kopiuj dane do schowka" mat-icon-button
            [cdkCopyToClipboard]="clipboardCopyValue">
            <mat-icon>content_copy</mat-icon>
        </button>
    </div>
</div>